import { FeatureFlagsKey } from '../../../../featureFlags';
import locales from './locales';

/**
 * Sort feature-flags by title
 * - create pairs of flag-key and title
 * - sort by title
 * - keep only flag-key
 */
export const sortFlagKeys = (flagKeys: FeatureFlagsKey[]) =>
  flagKeys
    .map((flagKey) => [flagKey, locales.features[flagKey].title] as const)
    .sort((flagPair1, flagPair2) => flagPair1[1].localeCompare(flagPair2[1]))
    .map((flagPair) => flagPair[0]);
